import BookDemoButton from "@/components/website/book-demo-button/BookDemoButton"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { Col, Row } from "antd"
import { FC } from "react"
import "./LogoSection.less"

import Typography from "@/components/typography/Typography"
import futureImage from "./assets/future-logo.webp"
import bgImage from "./assets/hex-bg-img.webp"

const { Title, Paragraph } = Typography

const subtitleParts = [
  { text: "Easetech helps teams process ", variant: "subtitle-secondary" },
  { text: "more applications ", variant: "subtitle-bold" },
  { text: "in ", variant: "subtitle-secondary" },
  { text: "less time ", variant: "subtitle-bold" },
  { text: "by reducing manual admin, simplifying workflows, and cutting delays.", variant: "subtitle-secondary" },
]

import hex01 from "./assets/hex001.svg"
import hex02 from "./assets/hex002.svg"
import hex03 from "./assets/hex003.svg"

const LogoSection: FC = () => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div className={"logo-section-wrapper"}>
      <div className={"bg-image-wrapper"}>
        <img src={bgImage} alt={""} loading={"lazy"} decoding={"async"} />
      </div>

      <div className={"container"}>
        <Row justify={"center"} className={"new-hero-section-row"}>
          <Col span={10} xxl={10} xl={10} lg={10} md={20} sm={20} xs={23} style={{ paddingBottom: 24 }}>
            <Row align={"middle"} justify={!(xxl || xl || lg) ? "center" : "start"} style={{ height: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={20} sm={20} xs={23}>
                <Title
                  level={xxl || xl || lg || md || sm ? 2 : 3}
                  color={"white"}
                  centered={!(xxl || xl || lg)}
                  style={{
                    paddingBottom: !(xxl || xl || lg) ? 0 : 24,
                    paddingTop: !(xxl || xl) ? 24 : 0,
                    fontSize: !(xxl || xl) ? undefined : 50,
                  }}
                >
                  <span>{"Lower costs.\n"}</span>
                  <span className={"bold orange"}>{"Higher output.\n"}</span>
                  <span>{"Better margins."}</span>
                </Title>

                <Col span={24}>
                  <Row>
                    <Col xxl={18} xl={18} lg={24} md={24} sm={24} xs={24}>
                      <Paragraph
                        style={{ paddingTop: 24, paddingBottom: xxl || xl || lg ? 80 : 32 }}
                        size={"lg"}
                        centered={!(xxl || xl || lg)}
                        color={"white"}
                        lh={"lh-lg"}
                      >
                        {subtitleParts.map((part, i) => (
                          <span key={i} className={part.variant}>
                            {part.text}
                          </span>
                        ))}
                      </Paragraph>
                    </Col>
                  </Row>
                </Col>

                <Row
                  align={"middle"}
                  style={{ height: "100%", paddingBottom: !(xxl || xl || lg) ? 12 : 0 }}
                  justify={!(xxl || xl || lg) ? "center" : "start"}
                >
                  <BookDemoButton type={"orange"} />
                </Row>

                <Col span={24} style={{ paddingTop: 16 }}>
                  <div className={"hex-icons-box"}>
                    <div className={"hex-icon-wrapper"}>
                      <img src={hex01} alt={""} loading={"lazy"} decoding={"async"} />
                    </div>
                    <div className={"hex-icon-wrapper"}>
                      <img src={hex02} alt={""} loading={"lazy"} decoding={"async"} />
                    </div>
                    <div className={"hex-icon-wrapper"}>
                      <img src={hex03} alt={""} loading={"lazy"} decoding={"async"} />
                    </div>
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>

          <Col
            className={"future-logo-col"}
            xxl={12}
            xl={14}
            lg={13}
            md={24}
            sm={24}
            xs={24}
            style={{ paddingLeft: xxl || xl || lg ? 24 : "unset", position: "relative" }}
          >
            <div className={"logo-img-wrapper"}>
              <img src={futureImage} alt={""} loading={"lazy"} decoding={"async"} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default LogoSection
